<template>
    <div class="apt-treat-summary">

      <p class="loading text-center" v-if="loadingProcedureSummaries"><i class="far fa-fw fa-pulse fa-spinner"></i></p>
      
      <div v-if="procedureSummaries" class="section section-outstanding row">
        <div class="col-7">
          <h4><i class="fas fa-calendar-times"></i> Outstanding / Incomplete Care</h4>
        </div> <!-- /.col-x -->
        <div class="col-5 text-right">
          <p v-if="encounter"><button @click="$emit('showSlides')" class="btn btn-link"><i class="fas fa-fw fa-external-link-square-alt"></i>View Encounter Slides</button></p>
        </div> <!-- /.col-x -->
        
        <div class="col-6" v-if="(procedureSummaries.advancingSurfList && procedureSummaries.advancingSurfList.length > 0) || (procedureSummaries.advancingToothList && procedureSummaries.advancingToothList.length > 0)">
          <h5>Advancing Disease</h5>
          <p>
            <span v-if="procedureSummaries.advancingToothList && procedureSummaries.advancingToothList.length > 0">Tooth: {{ procedureSummaries.advancingToothList.join(', ') }}</span>
            <span v-if="(procedureSummaries.advancingSurfList && procedureSummaries.advancingSurfList.length > 0) && (procedureSummaries.advancingToothList && procedureSummaries.advancingToothList.length > 0)">, </span>
            <span v-if="procedureSummaries.advancingSurfList && procedureSummaries.advancingSurfList.length > 0">Surf: {{ procedureSummaries.advancingSurfList.join(', ') }}</span>
          </p>
        </div> <!-- /.col-x -->

        <div class="col-6" v-if="procedureSummaries.rebuildingDescList && procedureSummaries.rebuildingDescList.length > 0">
          <h5>Rebuilding</h5>
          <p>{{ procedureSummaries.rebuildingDescList.join(', ') }}</p>
        </div> <!-- /.col-x -->
      </div> <!-- /.section-outstanding -->

      <div v-if="procedureSummaries && (procedureSummaries.nextPriorityLevel || procedureSummaries.nextPriorityLevel === 0) && procedureSummaries.priorityProcs && procedureSummaries.priorityProcs.length" class="section section-next-step">
        <h4><i class="fas fa-forward"></i> Next Step</h4>
        <p>Priority {{ procedureSummaries.nextPriorityLevel }}:</p>
        <!-- <div class="scrollable"> -->
          <ul class="list-unstyled">
            <li v-for="proc in procedureSummaries.priorityProcs" :key="proc.ProcCode" :title="proc.ProcCode">{{ proc.Descript }}</li>
          </ul>
        <!-- </div> /.scrollable -->
      </div> <!-- /.section-next-step -->
      
      <div v-if="procedureSummaries" class="text-center">
        <button @click.prevent="$router.push('/appointment/after')" class="btn btn-green btn-lg">Next<i class="fas fa-angle-right fa-fw"></i></button>
      </div>
    </div> <!-- /.apt-treat-summary -->
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'
import ListErrors from '../components/ListErrors.vue'
import moment from 'moment-timezone';
import { getFunctions, httpsCallable } from 'firebase/functions';

export default {
  components: {
    ListErrors,
  },
  data() {
    return {
      showSlidesModal: false,
      procedureSummaries: null,
      loadingProcedureSummaries: false,
    };
  },
  computed: {
    ...mapGetters(['user', 'user_props', 'custom_claims', 'appointment', 'encounter','treatment_plan', 'pat_num', 'pat_name']),
    
  },
  watch: {
    pat_num(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.loadProcedureSummaries();
      }
    },
  },
  methods: {
    async loadProcedureSummaries() {
      this.loadingProcedureSummaries = true;
      // console.log('Loading procedure summaries');
      // validate data
      if(!this.custom_claims || !this.custom_claims.customerId || !this.custom_claims.authorized_location || !this.user || !this.user.uid || !this.pat_num) {
        console.error('Missing required data');
        return false;
      }
      try {
        var loadProcLogsCodesByPatNum = Vue.functions.httpsCallable('loadProcLogsCodesByPatNum');
        const result = await loadProcLogsCodesByPatNum({
          patNum: this.pat_num,
          uid: this.user.uid,
          customerId: this.custom_claims.customerId,
          locationId: this.custom_claims.authorized_location,
        });
        this.procedureSummaries = result.data || [];
      } catch (error) {
        console.error('Error loading procedure logs:', error);
        this.procedureSummaries = [];
      }
      this.loadingProcedureSummaries = false;
    }
  },
  mounted() {
    if (this.pat_num) {
      this.loadProcedureSummaries();
    }
  },
  
};
</script>

<style lang="less" scoped>
@import "../assets/less/variables.less";

.section {
  padding-bottom: 40px;
  margin-bottom: 40px;
  border-bottom: 1px solid @dark-color;
}
h4 {
  font-size: 18px;
  font-weight: 600;
}
h5 {
  font-size: 16px;
  font-weight: 600;
}
.scrollable {
  max-height: 150px;
  overflow-y: auto;
  border-top: 1px solid @dim-color;
  border-bottom: 1px solid @dim-color;
  padding: 10px 0;
}

</style>
